// extracted by mini-css-extract-plugin
export default {"container":"ingredient-icon-list_container__V4Ah9","listElement":"ingredient-icon-list_listElement__FZLeX"};